import React from 'react';
import { useLocation } from 'react-router-dom';
import { MdSettings, MdApps } from 'react-icons/md';
import { FaClipboardList } from 'react-icons/fa';
import { FiSliders } from 'react-icons/fi';
import { SidebarItem, MenuAccordionItem } from '../SidebarComponents';

const MobileConfigMenu = () => {
  const location = useLocation();
  
  // Check if current route is active
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  // Check if an accordion is active based on subroutes
  const isAccordionActive = (parentPath) => {
    return location.pathname.startsWith(parentPath);
  };

  return (
    <MenuAccordionItem
      icon={MdSettings}
      label="Config. Mobile App"
      isActive={isAccordionActive('/config')}
      defaultIsOpen={isAccordionActive('/config')}
    >
      <SidebarItem 
        icon={MdApps} 
        label="Categorias" 
        to="/config/categorias" 
        active={isActive('/config/categorias')} 
        isSubmenuItem
      />
      <SidebarItem 
        icon={FaClipboardList} 
        label="Sub-Categorias" 
        to="/config/subCategorias" 
        active={isActive('/config/subCategorias')} 
        isSubmenuItem
      />
      <SidebarItem 
        icon={FiSliders} 
        label="Cores do Aplicativo" 
        to="/config/tema-aplicativo" 
        active={isActive('/config/tema-aplicativo')} 
        isSubmenuItem
      />
    </MenuAccordionItem>
  );
};

export default MobileConfigMenu;